import * as React from 'react';
import { connect } from 'react-redux';
import { resetDate, resetCoverItem, resetFromPersonalSubmit, setFnolIncidentEventList, setRiskItemAndIncident, setIncidentEvent } from '../../../actions/claimSubmitActions';
import { postToController } from '../../../actions/apiActions';
import '../../FNOL/FNOL.css'
import { showClaimDisclaimer } from '../../../actions/modalActions';
import KPDropdown from '../../BaseTemplate/SSPCustomComponentLibrary/KPDropdown/KPDropdown';
import { IDropdownData } from "../../../interfaces/KPDropdown/KPDropdownInterfaces";
import {
    BLING_BRAND_NEW_PRODUCT_ID, BLING_LIKE_NEW_PRODUCT_ID, BLING_SCREEN_FIX_PRODUCT_ID, 
    CAR_PRODUCT_VAPS_SCRATCH_AND_DENT_GUID, CAR_PRODUCT_VAPS_TYRE_AND_RIM_GUID, CAR_PRODUCT_VAPS_DINGS_AND_THINGS_GUID,
    CAR_CLAIM_VAPS_SCRATCH_AND_DENT_ID, CAR_CLAIM_VAPS_TYRE_AND_RIM_ID, CAR_CLAIM_VAPS_DINGS_AND_THINGS_ID,
} from '../../../constants/products';

class FnolStep1Sub1 extends React.Component<any, any>  {
    constructor(props) {
        super(props);

        this.state = {
            fnolStep: this.props.claimSubmit.selectedClaimStep.step,
            fnolSubStep: this.props.claimSubmit.selectedClaimStep.subStep,
            selectedCover: "",
            coverToggle: false,
            IncidentToggle: false,
            nextDisabled: true,
            Step1Submitted: false,
            causeOfCollision: "",
            hasDate: false,
            hasTime: false,
            Step1Disabled: false,
            name: this.props.profile.name + " " + this.props.profile.surname,
            contact: this.props.profile.cellphoneNumber,
            eventTypeList: [],
            selectedEvent: this.props.claimSubmit.incidentType,
        };

        this.handleCoverDropdownToggle = this.handleCoverDropdownToggle.bind(this);
        this.handleCoverSelection = this.handleCoverSelection.bind(this);
        this.handleIncidentToggle = this.handleIncidentToggle.bind(this);
        this.handleIncidentSelection = this.handleIncidentSelection.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.getIncidentTypes = this.getIncidentTypes.bind(this);
        this.getIncidentTypesByIncidentEventTypeId = this.getIncidentTypesByIncidentEventTypeId.bind(this);
    }

    async componentDidMount() {
        if (this.props.claimSubmit.fromPersonalSubmit && Object.keys(this.props.claimSubmit.selectedCover).length !== 0) {
            await this.setState({
                selectedCover: this.props.claimSubmit.selectedCover,
            })
            await this.getIncidentTypes(this.props.claimSubmit.selectedCover.id)
        }
        else if (this.props.claimSubmit.selectedRiskItem.length !== 0) {
            await this.setState({
                selectedCover: this.props.claimSubmit.selectedRiskItem,
            })
            await this.getIncidentTypes(this.props.claimSubmit.selectedRiskItem.id)
        }
        else {
            await this.props.dispatchResetCoverItem();
        }
        this.props.dispatchResetFromPersonalSubmit();
    }

    async handleCoverSelection(e: any) {
        await this.props.dispatchResetCoverItem();
        let coverItem = this.props.profile.personalPolicies[0].covers.filter(function (item) {
            return item.id == e;
        })
        if (coverItem.length !== 0 && coverItem[0].productName == "Car warranty") {
            await this.props.dispatchSetIncidentEvent("");
            await this.setState({ selectedCover: coverItem[0], selectedEvent: "", nextDisabled: false, eventTypeList: [] });
            await this.props.dispatchSetRiskItemAndIncident(coverItem[0], null);
        }
        else {
            if (coverItem.length === 0) {
                coverItem = this.props.profile.personalPolicies[0].covers.filter(function (item) {
                    return item.productName == "Portable possessions";
                })
            }
            if (coverItem[0].productName == "Portable possessions") {
                coverItem = coverItem[0].riskItems[0].portablePossessions.filter(function (item) {
                    return item.id == e;
                })
                coverItem = [{ "riskItems": [coverItem[0]], "id": coverItem[0].id, "productName": "Portable possessions" }]
            }

            await this.props.dispatchSetIncidentEvent("");
            await this.getIncidentTypes(coverItem[0].id);
            await this.setState({ selectedCover: coverItem[0], selectedEvent: "" });
            await this.props.dispatchSetRiskItemAndIncident(coverItem[0], null);
        }
    }

    async getIncidentTypes(riskItemId) {
        let eventTypes: any = [];
        await postToController(this.props.dispatch, 'GetAllEventTypes', JSON.stringify({ Parameter: riskItemId })).then(async (response) => {
            eventTypes = response;
        });

        if (this.props.ssp.drivableVapClaimsEnabled) {
            let coverItem = this.props.profile.personalPolicies[0].covers.filter(x => x.id === riskItemId);
            coverItem = (coverItem && coverItem.length > 0) ? coverItem[0] : null;
            if (coverItem && (coverItem.productName.toLowerCase() === 'car' || coverItem.productName.toLowerCase() === 'chilli')) {
                if (coverItem.vaps != null) {
                    coverItem.vaps.forEach(vap => {
                        let id = 0;
                        switch (vap.id.toUpperCase()) {
                            case CAR_PRODUCT_VAPS_TYRE_AND_RIM_GUID: { id = CAR_CLAIM_VAPS_TYRE_AND_RIM_ID; break; }
                            case CAR_PRODUCT_VAPS_SCRATCH_AND_DENT_GUID: { id = CAR_CLAIM_VAPS_SCRATCH_AND_DENT_ID; break; }
                            case CAR_PRODUCT_VAPS_DINGS_AND_THINGS_GUID: { id = CAR_CLAIM_VAPS_DINGS_AND_THINGS_ID; break; }
                        }
                        if (id > 0) {
                            eventTypes.push({ id, description: vap.title });
                        }
                    });
                }
            }
        }

        let otherEvent = (eventTypes.filter(x => x.id === 999));
        if (otherEvent.length > 0) {
            let eventTypesSorted = eventTypes.filter(x => x.id !== 999).sort((a, b) => (a.description < b.description ? -1 : 1));
            eventTypes = eventTypesSorted;
            eventTypes.push(otherEvent[0]);
        }
        await this.setState({ eventTypeList: eventTypes });
    }

    async handleCoverDropdownToggle(e: any) {
        await this.setState({
            coverToggle: !this.state.coverToggle
        });
    }

    async handleIncidentSelection(e: any) {
        let eventType = this.state.eventTypeList.filter(function (item) {
            return item.id == e
        })
        await this.props.dispatchSetIncidentEvent(eventType[0]);
        await this.setState({ nextDisabled: false });
        await this.getIncidentTypesByIncidentEventTypeId(eventType[0]);
    }

    async handleIncidentToggle(e: any) {
        await this.setState({
            IncidentToggle: !this.state.IncidentToggle
        });
    }

    async handleNext(isMobile: boolean) {
        this.props.dispatchResetDate();
        await this.props.dispatchSetRiskItemAndIncident(this.props.claimSubmit.selectedRiskItem, this.props.claimSubmit.incidentType);
        this.props.dispatchAction(showClaimDisclaimer());
    }

    async getIncidentTypesByIncidentEventTypeId(incidentEventType) {
        if (this.props.claimSubmit.selectedRiskItem.productName.toLowerCase() === "portable possessions" && this.props.claimSubmit.selectedRiskItem.riskItems[0].isCellphone) {
            await postToController(this.props.dispatch, 'GetBlingIncidentTypesByIncidentEventTypeId', JSON.stringify({ PolicyRiskItemId: this.props.claimSubmit.selectedRiskItem.id, IncidentEventTypeId: incidentEventType.id })).then(async (response) => {
                await this.setState({ incidentTypeList: response });
                await this.props.dispatchSetIncidentEventList(response, incidentEventType);
                return true;
            })
        }
        else if (!this.props.ssp.drivableClaimsEnabled || this.props.claimSubmit.incidentType.id == 13) {
            await postToController(this.props.dispatch, 'GetIncidentTypesByIncidentEventTypeId', JSON.stringify({ EventTypeId: incidentEventType.id })).then(async (response) => {
                await this.setState({ incidentTypeList: response });
                await this.props.dispatchSetIncidentEventList(response, incidentEventType);
                return true;
            })
        }
        else {
            await this.props.dispatchSetIncidentEventList([], incidentEventType);
        }
    }

    public render() {
        let eventTypes: any = [];
        let filterItems;
        var covers: IDropdownData = {
            id: "",
            description: "",
            image: "",
            productName: "",
        }

        if (this.state.eventTypeList) {
            if (this.props.claimSubmit.selectedRiskItem.productName === "Caravan" || this.props.claimSubmit.selectedRiskItem.productName === "Trailer" || this.props.claimSubmit.selectedRiskItem.productName === "Watercraft") {
                filterItems = this.state.eventTypeList.filter(item => item.description !== "Collision")
                eventTypes = filterItems.filter(item => item.description !== "Windscreen/broken window (sunroof excluded)")
            }
            else if (this.props.profile.countryId === 157) {
                eventTypes = this.state.eventTypeList.filter(item => item.description !== "Windscreen/broken window (sunroof excluded)");
            }
            else if (this.props.claimSubmit.selectedRiskItem.product === BLING_BRAND_NEW_PRODUCT_ID || this.props.claimSubmit.selectedRiskItem.product === BLING_LIKE_NEW_PRODUCT_ID || this.props.claimSubmit.selectedRiskItem.product === BLING_SCREEN_FIX_PRODUCT_ID || this.props.claimSubmit.selectedRiskItem.productName === "Portable possessions") {
                eventTypes = this.state.eventTypeList
            }
            else {
                eventTypes = this.state.eventTypeList.filter(item => item.description !== "Intentional damage");
            }
        }

        if (this.props.profile.personalPolicies[0] !== undefined) {
            if (this.props.ssp.cellphoneClaimsEnabled) {
                covers = this.props.profile.personalPolicies[0].selectableCovers.sort((a, b) => a.productName.toLowerCase() > b.productName.toLowerCase() ? 1 : -1)
                    .filter((cover) => !cover.productName.startsWith("Code red") && !cover.productName.startsWith("Warranty") && !cover.productName.startsWith("Other"))
                    .map(item => {
                        return ({
                            description: item.description,
                            id: item.id,
                            image: item.image,
                            productName: item.productName
                        }) as IDropdownData;
                    });
            }
            else {
                covers = this.props.profile.personalPolicies[0].covers
                    .filter((cover) => cover.isMainline === true && !cover.productName.startsWith("Portable") && !cover.productName.startsWith("Brand-new") && !cover.productName.startsWith("Like-new") && !cover.productName.startsWith("Screen-fix") && !cover.productName.startsWith("Code red") && !cover.productName.startsWith("Warranty") && !cover.productName.startsWith("Personal") && cover.riskItems[0] !== undefined)
                    .map(item => {
                        return ({
                            description: item.riskItems[0].description,
                            id: item.id,
                            image: item.image,
                            productName: item.productName
                        }) as IDropdownData;
                    });
            }
        }

        let incidentEventTypes = <div></div>;
        if (this.props.claimSubmit.incidentEventList) {
            incidentEventTypes = this.props.claimSubmit.incidentEventList;
        }

        let selectedRiskItem = ""
        if (this.props.claimSubmit.selectedRiskItem?.id) {
            if (!this.props.claimSubmit.selectedRiskItem.riskItems) {
                selectedRiskItem = this.props.claimSubmit.selectedRiskItem
            }
            else {
                selectedRiskItem = this.props.claimSubmit.selectedRiskItem.riskItems[0]
            }
        }

        let selectedIncidentType = ""
        if (this.props.claimSubmit.incidentType) {
            selectedIncidentType = this.props.claimSubmit.incidentType
        }

        return (
            <div className={'tab-pane col-12 nopa' + (this.props.claimSubmit.selectedClaimStep.step === 1 ? ' active' : '')} id="GetStarted" role="tabpanel">
                <div className="row noma">
                    <div className="col-12 nopa ssp-header-lets-get-started-header-container">
                        <h3>Let's get started</h3>
                        <p>Tell us about your claim by using these drop-downs:</p>
                        <hr />
                    </div>
                </div>
                <div className="row noma">
                    <div className="col-12 nopa fnol-product-type-selector-holder">
                        {covers &&
                            <KPDropdown
                                id={"ChooseItem-fnol"}
                                isImageDropdown={true}
                                showLabelAfterSelection={true}
                                showLabelInside={true}
                                showLabelOutside={false}
                                isRiskItem={true}
                                labelAfterSelection={"Selected item"}
                                title={"Please select an item"}
                                data={covers}
                                handleSelection={(e) => this.handleCoverSelection(e)}
                                selectedValue={selectedRiskItem}
                            />
                        }
                    </div>
                    {this.state.eventTypeList.length > 0 && selectedRiskItem &&
                        <div className="col-12 mt-20px nopa">
                            <KPDropdown
                                id={"IncidentType-fnol"}
                                showLabelAfterSelection={true}
                                showLabelInside={true}
                                labelAfterSelection={"What are you claiming for"}
                                label={"What are you claiming for"}
                                title={"What are you claiming for"}
                                data={eventTypes}
                                handleSelection={(e) => this.handleIncidentSelection(e)}
                                selectedValue={selectedIncidentType}
                            />
                        </div>
                    }
                </div>
                <div className="row noma">
                    <div className="col-12 fnol-start-buttons-container">
                        <button className="btn btn-solid-red w-100 fnol-start-button-desktop desktoponly" disabled={this.state.nextDisabled} onClick={(e) => this.handleNext(false)}>Start</button>
                        <button className="btn btn-solid-red fnol-start-button-mobile ismobile" disabled={this.state.nextDisabled} onClick={() => this.handleNext(true)}>Start</button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        claimSubmit: state.claimSubmit,
        ssp: state.ssp
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e),
        dispatchSetIncidentEventList: (list, event) => dispatch(setFnolIncidentEventList(list, event)),
        dispatchSetIncidentEvent: (event) => dispatch(setIncidentEvent(event)),
        dispatchSetRiskItemAndIncident: (riskItem, incidentType) => dispatch(setRiskItemAndIncident(riskItem, incidentType)),
        dispatchResetDate: () => dispatch(resetDate()),
        dispatchResetCoverItem: () => dispatch(resetCoverItem()),
        dispatchResetFromPersonalSubmit: () => dispatch(resetFromPersonalSubmit()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FnolStep1Sub1)